export const blockingAndMutingContent = `How we operate Batesky for platform trust and safety.

## Human Moderation Service
Batesky operates [@moderation.batesky.app](https://batesky.app/profile/moderation.batesky.app), our moderation service that receives in-app user reports. All user reports are anonymous and any report that we receive will be resolved within 5 business days or 24 hours for illegal content.

## Automated Moderation
All content posted is scanned by systems that include Hasher-Matcher-Actioner (HMA) to detect, identify and remove Child Sexual Abuse Material (CSAM). Any CSAM detected will be reported to authorities.

## Bluesky Moderation
In addition to the Batesky moderation, if someone reports your post from a different app like Bluesky, their respective moderation team can take actions on your posts or account to take down a post or add labels to it.

If you need further help, contact us at [support@batesky.app](mailto:support@batesky.app).
`
